module.exports = __webpack_public_path__ + "img/solarenergy.27cfa516.png";